import { module as ModuleJS } from "modujs";


export default class extends ModuleJS {
    constructor(m) {
        super(m);

        this.items = this.$("items")[0]; 
        this.switch = this.$("switch")[0]; 
        this.grid = this.$("grid")[0];
        this.row = this.$("row")[0];
        // console.log(this.items);
        // console.log(this.switch);
        // console.log(this.grid);
        // console.log(this.row);

        
    }

    init() { 
        this.activeGridMode = this.activeGridMode.bind(this);
        this.activeRowMode = this.activeRowMode.bind(this);
        this.bindEvents(); 
    }

    update(newContainer) { this.bindEvents(newContainer); }

    destroy(oldContainer) {}

    getitems() {

    }

    activeGridMode() {
        this.items.classList.remove("-display-row");
        this.items.classList.add("-display-grid");
        this.grid.classList.add('active');
        this.row.classList.remove('active');
    }

    activeRowMode() {
        this.items.classList.remove("-display-grid");
        this.items.classList.add("-display-row");
        this.row.classList.add('active');
        this.grid.classList.remove('active');
    }


    bindEvents(el) {
        this.grid.addEventListener("click", this.activeGridMode, false);
        this.row.addEventListener("click", this.activeRowMode, false);
    }

}
